import { render, staticRenderFns } from "./FieldUserRetailerProduct.vue?vue&type=template&id=8d1ece66&"
import script from "./FieldUserRetailerProduct.vue?vue&type=script&lang=js&"
export * from "./FieldUserRetailerProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports